import {all, fork, put, select, takeLatest} from "redux-saga/effects";
import {LOAD_VIDEOS_REQUEST, REMOVE_VIDEO_REQUEST, UPLOAD_VIDEO_REQUEST} from "../reducers/videos/types";
import {getVideosFetch, postVideoFetch, removeVideoFetch} from "../api";
import {getVideos, removeVideo, setError, setLoading, setVideos} from "../reducers/videos/actions";

export function* removeVideoById() {
    yield takeLatest(REMOVE_VIDEO_REQUEST, function* ({payload}) {
        yield put(setLoading(true));
        const state = yield select();
        const access_token = state.profile.user.moderator.access_token;
        try {
            const rs = yield removeVideoFetch({id: payload.id, access_token});
            yield put(removeVideo(payload.id));
        } catch (e) {
            yield put(setError(true));
        }
        yield put(setLoading(false));
    })
}

export function* getVideosSaga() {
    yield takeLatest(LOAD_VIDEOS_REQUEST, function* () {
        try {
            yield put(setLoading(true));
            const state = yield select();
            const access_token = state.profile.user.moderator.access_token;
            const rs = yield getVideosFetch({access_token});
            yield put(setVideos(rs.data));
        } catch (e) {
            yield put(setError(true));
        }

        yield put(setLoading(false));
    })
}

export function* uploadVideo() {
    yield takeLatest(UPLOAD_VIDEO_REQUEST, function* ({payload}) {

        yield put(setLoading(true));
        try {
        const state = yield select();
        const access_token = state.profile.user.moderator.access_token;
            const rs = yield postVideoFetch({video: payload.video, access_token});
            yield put(getVideos());
        } catch (e) {
            yield put(setError(true));
        }
        yield put(setLoading(false));
    })
}

function* videosSaga() {
    yield all([
        fork(uploadVideo),
        fork(getVideosSaga),
        fork(removeVideoById),
    ])
}

export default videosSaga;
